import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdTransitionActionContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/wf/md/transition-actions

@Injectable({ providedIn: "root" })
export class WfMdTransitionActionService extends BaseApiTemplateService<WfMdTransitionActionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transition-actions";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transition-actions";
    this.httpClient = http;
  }
}
